export enum WebsocketActionType {
  SendMessage = '@quidproquo-webserver/Websocket/SendMessage',
}
